import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { faker } from '@faker-js/faker';
import { Box, Heading } from "@chakra-ui/react";
import CustomCard from "../ui/card";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
    indexAxis: 'y' as const,
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      legend: {
        position: 'right' as const,
      },
      title: {
        display: true,
        text: '(+43%) than last year',
      },
    },
};

const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

export const data = {
  labels,
  datasets: [
    {
      label: 'Dataset 1',
      data: labels.map(() => faker.number.int({ min: -100, max: 1500 })),
      borderColor: 'rgb(33, 101, 209)',
      backgroundColor: 'rgb(33, 101, 209)',
    },
  ],
};

export function OverviewConversion({ width, className }: { width?: string, className?: string }) {
    return (
        <CustomCard
            width='65%'
            marginRight='1rem'
            children={(
                <>
                    <Heading as='h4' size='md' marginBottom='2'>Conversion Rates</Heading>
                    <Box className={className} width='100%'>
                        <Bar options={options} data={data} width='100%' height='80px' />
                    </Box>
                </>
            )} 
        />
    );
}